import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";

export const prefix = "[Set Partial Grades Enabled]";

const setPartialGradesEnabledActions = {
  request: `${prefix} Load`,
  requestSuccess: `${prefix} Load success`,
  requestFail: `${prefix} Load fail`,
};

export const setPartialGradesEnabledLoad = createAction(
  setPartialGradesEnabledActions.request,
  props<{
    CourseId: string;
    GroupId: string;
    partial_grades_enabled: boolean;
  }>(),
);

export const setPartialGradesEnabledLoadSuccess = createAction(
  setPartialGradesEnabledActions.requestSuccess,
  props<{ partial_grades_enabled: boolean }>(),
);

export const setPartialGradesEnabledLoadFailure = createAction(
  setPartialGradesEnabledActions.requestFail,
  props<{ error: HttpErrorResponse }>(),
);

